import { Dictionary } from '../../global/types';

/**
 * converts ES6 Map to object, leaving only string values as keys
 */
export const mapToObject = <K, V>(map: Map<K, V>): Dictionary<V> => {
  const entries = Array.from(map);
  return entries.reduce((acc, [key, value]) => {
    if (typeof key === 'string') {
      acc[key] = value;
    }
    return acc;
  }, {} as Dictionary<V>);
};
